import React from 'react';
import PropTypes from 'prop-types';
/**
 * 버튼 : 아이콘
 */
const IconButton = ({ icon, styleDef, viewStatus, clickEvt, title, label, error }) => {
  const set = '';
  return (
    <div className="_at_icon_button_div" style={styleDef}>
      {viewStatus === '_dim' ? <div className="_dim" /> : ''}
      <button type="button" aria-label={label} title={title} className="_button_div" onClick={clickEvt} >
        <div className="_icon">
          {/* <i className={icon} style={{ color: styleDef.color, "font-size": "30px" }} /> */}
          <i className={icon} style={styleDef} />
        </div>
      </button>
    </div>
  );
};

IconButton.propTypes = {
  icon: PropTypes.string,
  styleDef: PropTypes.object,
  viewStatus: PropTypes.string,
  clickEvt: PropTypes.func,
  title: PropTypes.string,
  label: PropTypes.string,
  error: PropTypes.object,
};
IconButton.defaultProps = {
  icon: 'ri-close-fill',
  styleDef: {},
  viewStatus: '',
  clickEvt: () => {},
  title: "",
  label: "",
  error: { error: false, msg: '' },
};

export default IconButton;
